import { render, staticRenderFns } from "./SystemComponentAdd.vue?vue&type=template&id=22341342&"
import script from "./SystemComponentAdd.vue?vue&type=script&lang=js&"
export * from "./SystemComponentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports